// extracted by mini-css-extract-plugin
module.exports = {"title":"pets_title__vqGun","item":"pets_item__yQ6RJ","size":"pets_size__1qvRV"};